jQuery(() => {
  var shimanoModal = document.getElementById("shimanoModal")
  var activeNavElemet = $(".navbar .nav-item .active")
  var vimeoVideo
  var videoModel
  if (shimanoModal !== null) {
    shimanoModal.addEventListener("show.bs.modal", (event) => {
      // $(".navbar").addClass("invisible")
      // Button that triggered the modal
      let button = event.relatedTarget
      vimeoVideo = button.getAttribute("data-vimeo") != undefined
      // Extract info from data-bs-* attributes
      let modalTarget = button.getAttribute("data-bs-modalTarget")
      let modalType = button.getAttribute("data-bs-modalType")
      let modalInput = $(modalTarget).html()
      let modalExtraClasses = button.getAttribute("data-extra-class")
      // Add any custom classes to modal
      shimanoModal.classList = `modal fade ${modalExtraClasses != undefined ? modalExtraClasses : ""}`

      // Update the modal's content.
      document.body.style.overflow = "auto"
      //this if statement is needed to remove content that is outside of the modal body
      if (modalType == "modal-full-v2") {
        $(".navbar-brand").addClass("invisible")
        $(".modal-header").removeClass("container")
        $(".modal-header .close-modal-button").addClass("modal-v2__close-button")
      }
      let modalBodyInput = shimanoModal.querySelector(".modal-body")
      activeNavElemet.removeClass("active")

      modalBodyInput.innerHTML = modalInput
      if (modalType == "modal-image") {
        let preloadImage = $("#preloaded-image")
        $(preloadImage).prependTo($(".modal-body"))
      }
      videoModel = $("#shimanoModal .modal-body #player")
      if (videoModel != null && vimeoVideo) {
        $("#shimanoModal .close-modal-button").css("top", "60px")
      }

      shimanoModal.dataset.activeModal = modalTarget.replace('#', '')

      trackModalOpened(shimanoModal)
    })
    shimanoModal.addEventListener("hide.bs.modal", (event) => {
      if (videoModel != null && vimeoVideo) {
        $("#shimanoModal .close-modal-button").css("top", "auto")
      }
      //close
      $(".modal-header").addClass("container")
      $(".modal-header .close-modal-button").removeClass("modal-v2__close-button")
      activeNavElemet.addClass("active")
      $(".navbar").removeClass("invisible")
      $(".navbar-brand").removeClass("invisible")
      $(".navbar-nav .nav-link.active::before").css("visibility", "visible")
      $(".modal-body").empty()
      trackModalClosed(shimanoModal)
    })
  }

  $(".close-modal").on("click", () => {
    if (shimanoModal === null) return

    $("#shimanoModal").modal("hide")
  })

  function trackModalOpened(modal) {
    const activeModal = modal.dataset.activeModal
    switch (activeModal) {
      case 'search-selector':
        modal.dataset.trackerIdentifier = 'search-modal'
        modal.dataset.modalEvent = 'opened'
        trackParcer(modal)
        break
  
      default:
        break
    }
  }
  
  function trackModalClosed(modal) {
    const activeModal = modal.dataset.activeModal
    switch (activeModal) {
      case 'search-selector':
        modal.dataset.trackerIdentifier = 'search-modal'
        modal.dataset.modalEvent = 'closed'
        trackParcer(modal)
        break
  
      default:
        break
    }
  
    modal.dataset.trackerIdentifier = ''
    modal.dataset.activeModal = ''
    modal.dataset.modalEvent = ''
  }
})
